import React, {useEffect} from 'react'
import { useRouteMatch } from "util/router.js";
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser(); 

function CommunityPage(props) {

    const match = useRouteMatch()

    const reactElement = () => {
        var element = null
        element = htmlToReactParser.parse(`<iframe style="border: 0; box-shadow: none; width: 100%; height: 85vh;" src="https://community.sutrapro.com?iframe=true"></iframe>`)
        return (
            <div className="mb-3">
                {element}
            </div>
        )
    } 

    return (
        <>
        {reactElement()}
        </>
        
      );
}

export default CommunityPage